export function getEvents(state: any) {
    return state.outreach.events;
}

export function getProjects(state: any) {
    return state.outreach.projects;
}

export function getDatasets(state: any) {
    return state.outreach.datasets;
}

export function isLoading(state: any) {
    return state.outreach.isLoading;
}
